var map = {
	"./-L6gvfOBnH-pEtb7RZZK.jpg": "YTzx",
	"./-L6gw6lad-OOG6GrFXMG.jpg": "uPHQ",
	"./-M8_ATUZ3Nq9TuG16MhR.jpg": "4fKj",
	"./-MbQu4jtXumUKuVIzcRx.jpg": "QEda"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/iBA";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\.jpg$
// module id = /iBA
// module chunks = 1